/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginToken
 */
export interface LoginToken {
    /**
     * 
     * @type {string}
     * @memberof LoginToken
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof LoginToken
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LoginToken
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof LoginToken
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof LoginToken
     */
    token: string;
    /**
     * 
     * @type {Date}
     * @memberof LoginToken
     */
    expiry: Date;
    /**
     * 
     * @type {string}
     * @memberof LoginToken
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginToken
     */
    vehicleDeviceId?: string | null;
}

/**
 * Check if a given object implements the LoginToken interface.
 */
export function instanceOfLoginToken(value: object): value is LoginToken {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('expiry' in value) || value['expiry'] === undefined) return false;
    return true;
}

export function LoginTokenFromJSON(json: any): LoginToken {
    return LoginTokenFromJSONTyped(json, false);
}

export function LoginTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginToken {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'description': json['description'],
        'token': json['token'],
        'expiry': (new Date(json['expiry'])),
        'userId': json['userId'] == null ? undefined : json['userId'],
        'vehicleDeviceId': json['vehicleDeviceId'] == null ? undefined : json['vehicleDeviceId'],
    };
}

export function LoginTokenToJSON(json: any): LoginToken {
    return LoginTokenToJSONTyped(json, false);
}

export function LoginTokenToJSONTyped(value?: LoginToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'description': value['description'],
        'token': value['token'],
        'expiry': value['expiry'].toISOString(),
        'userId': value['userId'],
        'vehicleDeviceId': value['vehicleDeviceId'],
    };
}

